import React from "react";
import moment from "moment";
import { withRouter } from "react-router";

const ICON_MAP = {
  Inventory: "fa-cog",
  SalesOrder: "fa-dollar",
  ManagedRepairOrder: "fa-recycle",
  PurchaseOrder: "fa-shopping-cart",
  RepairOrder: "fa-wrench",
  CostAdjustment: "fa-wrench",
  Lot: "fa-shopping-cart"
};

const LINK_MAP = {
  Inventory: "/inventories",
  Lot: "/lots",
  ManagedRepairOrder: "/managed-repair-orders",
  PurchaseOrder: "/purchase-orders",
  RepairOrder: "/repair-orders",
  SalesOrder: "/sales-orders"
};

function Row({ history, log }) {
  const url =
    log.reference_record_type === "CostAdjustment"
      ? `/inventories/${log.reference_record.inventory_id}`
      : `${LINK_MAP[log.reference_record_type]}/${log.reference_record.uuid}`;

  return (
    <tr
      style={{
        backgroundColor: "rgba(255, 255, 255, 0.1)"
      }}
      onClick={() => {
        history.push(url);
      }}
    >
      <td>
        <i className={`fa fa-fw ${ICON_MAP[log.reference_record_type]}`} />
      </td>
      <td>
        <div className="pull-left">{log.message}</div>
      </td>
      <td>
        <div className="pull-left">
          <a
            href={log.quickbooks_link}
            rel="noopener noreferrer"
            target="_blank"
          >
            {log.quickbooks_link}
          </a>
        </div>
      </td>
      <td width="25%">
        <em className="small text-muted">
          {moment(log.created_at).calendar({
            lastWeek: "dddd [at] h:mm a"
          })}
        </em>
      </td>
    </tr>
  );
}

export default withRouter(Row);



// WEBPACK FOOTER //
// ./app/modules/AccountingLogs/Search/Row.jsx